import * as React from "react";

const Icon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} width="86" height="38" viewBox="0 0 86 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.9375" width="10" height="10" rx="1" fill="#D9D9D9" />
    <rect x="13.0625" y="3" width="72" height="6" rx="1" fill="#D9D9D9" />
    <rect x="0.9375" y="14" width="10" height="10" rx="1" fill="#D9D9D9" />
    <rect x="13.0625" y="16" width="72" height="6" rx="1" fill="#D9D9D9" />
    <rect x="0.9375" y="28" width="10" height="10" rx="1" fill="#D9D9D9" />
    <rect x="13.0625" y="29" width="72" height="6" rx="1" fill="#D9D9D9" />
    <path d="M8 31L4 35M4 31L8 35" stroke="#667080" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 3L4 7M4 3L8 7" stroke="#667080" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default Icon;
